const { getOffsetTop } = window.BAO.Utils

export class ProductFixedBar extends window.BAO.CustomElement() {
  connectedCallback () {
    super.connectedCallback()

    this.isTicking = false
  }

  setupListeners () {
    super.setupListeners()

    this.requestTick = this.requestTick.bind(this)
    this.updateEl = this.updateEl.bind(this)
    this.onScroll = this.onScroll.bind(this)

    window.addEventListener('scroll', this.onScroll, { passive: true })

    this.handleScrollBackClick = this.handleScrollBackClick.bind(this)
    this.listeners.add(
      this.els.fixedButton.element,
      'click',
      this.handleScrollBackClick,
    )

    this.setVisibility()
  }

  onScroll () {
    this.requestTick()
  }

  requestTick () {
    if (!this.isTicking) requestAnimationFrame(this.updateEl)

    this.isTicking = true
  }

  updateEl () {
    this.isTicking = false

    this.setVisibility()
  }

  setVisibility () {
    const formObject = document.querySelector(
      '[data-product-fixed-bar-external-el="form"]',
    )

    const formOffsetTop = getOffsetTop(formObject) + formObject.offsetHeight

    this.setAttribute('aria-hidden', window.scrollY < formOffsetTop)
  }

  handleScrollBackClick () {
    window.scrollTo({
      top:
        getOffsetTop(
          document.querySelector('[data-product-fixed-bar-external-el="form"]'),
        ) - 90,
      behavior: 'smooth',
    })
  }
}

if (!customElements.get('product-fixed-bar')) {
  customElements.define('product-fixed-bar', ProductFixedBar)
}
